import { render, staticRenderFns } from "./PDFViewer.vue?vue&type=template&id=655d78a8&scoped=true&"
import script from "./PDFViewer.vue?vue&type=script&lang=js&"
export * from "./PDFViewer.vue?vue&type=script&lang=js&"
import style0 from "pdfvuer/dist/pdfvuer.css?vue&type=style&index=0&lang=css&"
import style1 from "./PDFViewer.vue?vue&type=style&index=1&id=655d78a8&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655d78a8",
  null
  
)

export default component.exports